import { render, staticRenderFns } from "./souvenir.vue?vue&type=template&id=90d32a9e&"
import script from "./souvenir.js?vue&type=script&lang=js&"
export * from "./souvenir.js?vue&type=script&lang=js&"
import style0 from "./souvenir.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports